module.exports = __webpack_public_path__ + "static/media/refresh.c427af87.svg";